class passwordPoliciesCtrl {
    constructor($scope, httpRequest, formvalidateApi) {
        $scope.passwordPolicy = { }

        httpRequest.get_passwordPolicy(0).then((res) => {
            // 获取初始化是密码策略
            $scope.passwordPolicy = res.data.value
            $scope.passwordPolicy.cententPolicy = Boolean($scope.passwordPolicy.cententPolicy)
            $scope.passwordPolicy.mustChange = Boolean($scope.passwordPolicy.mustChange)
            $scope.passwordPolicy.exceptionLock = Boolean($scope.passwordPolicy.exceptionLock)
        })
        $scope.caseSencitive = function caseSencitive() {
            if ($scope.passwordPolicy.caseSencitive === 1) {
                $scope.passwordPolicy.caseSencitive = 0
            } else {
                $scope.passwordPolicy.caseSencitive = 1
            }
        }
        $scope.postPasswordPolicy = () => {
            const mark = formvalidateApi.run()
            if (mark) {
                const param = {
                    ...$scope.passwordPolicy,
                }
                param.cententPolicy = Number(param.cententPolicy)
                param.mustChange = Number(param.mustChange)
                param.exceptionLock = Number(param.exceptionLock)
                httpRequest.post_passwordPolicy(param, '保存密码策略成功')
            }
        }

        $scope.validateRules = {
            errNum: [
                {
                    erromsg: '请输入正整数',
                    condition(value) {
                        // 规则
                        const regex = /^[0-9]*[1-9][0-9]*$/

                        const result = (value == '' | value == null) | regex.test(value)
                        // true 标示显示 errmsg  false 标示验证通过
                        return !result
                    },
                },
            ],
        }
    }
}
passwordPoliciesCtrl.$inject = ['$scope', 'httpRequest', 'formvalidateApi']
export default passwordPoliciesCtrl



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/passwordPolicies/passwordPoliciesCtrl.js